<template>
    <div class="wrapper">
        <div class="d-block" style="margin-bottom:0px; border-bottom:0px;margin-top: 20px;">
            <div class="d-top">
                订单号：
                <span class="theme">{{ order_id }}</span>
                订单金额：
                <span class="theme">￥{{ orderInfo.order_amount }}</span>
                已付金额：
                <span class="theme">￥{{ orderInfo.payed}}</span>
                <br>
                订单状态：
                <span>
					<b>{{ getCusOrderStatus(orderInfo) }}</b>
				</span>

                <div class="state-handle">

                    <template v-if="orderInfo.order_type==9&&orderInfo.customized_status==3&&orderInfo.design_id==userInfo.id">
						<span class="btn">
							<router-link
                                    :to="{ name: 'uploadDesign', params: { order_id: order_id } }">上传设计</router-link>
						</span>
                    </template>
                    <template v-if="orderInfo.order_type==9&&orderInfo.customized_status==1&&orderInfo.user_id==userInfo.id">
						<span class="btn" @click="toPay(order_id)">
							付保证金
						</span>

                    </template>

                    <template v-if="orderInfo.order_type==9&&orderInfo.customized_status==4&&orderInfo.user_id==userInfo.id">
						<span class="btn" @click="toPay(order_id)">
							确认设计
						</span>

                        <span class="btn" @click="redes()">
							重新设计
						</span>
                    </template>
                    <template v-if="orderInfo.order_type==9&&orderInfo.customized_status==7&&orderInfo.user_id==userInfo.id">
						<span class="btn" @click="toPay(order_id)">
							付清尾款
						</span>

                    </template>
                    <template v-if="orderInfo.order_type==9&&orderInfo.customized_status==9&&orderInfo.user_id==userInfo.id">
						<span class="btn" @click="tackDelivery(order_id)">
							确认收货
						</span>
                    </template>
                </div>
            </div>


        </div>
        <div style=" margin: 0 -40px; background: #F5F5F5; height: 50px;"></div>
        <div class="noborder">
            <div  style="padding-top: 0;">
                <div class="top-head">查看订单状态</div>
                <div style=" margin: 0 -40px; background: #F5F5F5; height: 1px;"></div>
            </div>
            <div class="d-block" style=" margin-top: 40px;">

                <div>
                    <div class="d-title"><span class="step">第一步</span>需求提交，保证金未支付</div>
                </div>
                <div class="state-handle" v-if="orderInfo.customized_status>=1"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第二步</span>保证金已支付，待分配设计师</div>
                <DemandTable v-if="orderInfo.memo" :configstr="orderInfo.memo"></DemandTable>
                <div class="state-handle" v-if="orderInfo.customized_status>=2"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第三步</span>设计师已分配，方案制作中</div>
                <div class="state-handle" v-if="orderInfo.customized_status>=3"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
                <table class="info-table">
                    <tbody>
                    <tr>
                        <th>设计师等级：</th>
                        <td>{{desInfo.name}}</td>
                    </tr>
                    <tr>
                        <th>设计师姓名：</th>
                        <td>{{desInfo.username}}</td>
                    </tr>
                    <tr>
                        <th>设计师联系方式：</th>
                        <td>{{desInfo.mobile}}</td>
                    </tr>

                    </tbody>
                </table>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第四步</span>定制方案已提交，待确认</div>
                <DesTable v-if="orderInfo.mark&&orderInfo.customized_status>=4" :price="orderInfo.order_amount" :configstr="orderInfo.mark" :file_path="orderInfo.file_path" :imgurl_path="orderInfo.imgurl_path" ></DesTable>
                <div class="state-handle" v-if="orderInfo.customized_status>=4"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第五步</span>方案已确认，首款待付</div>
                <div class="info-table">

                </div>
                <div class="state-handle" v-if="orderInfo.customized_status>=5"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>

            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第六步</span>首款已支付，制作中</div>

                <div class="order-progress">
                    <ul class="progress-list">
                        <li class="step" :class="(orderInfo.pro_status >= 1&&proDetails[0]) || orderInfo.customized_status>6 ? 'past' : ''">
                            <div>
                                <span class="text">确认进入ERP系统</span>
                            </div>
                        </li>
                        <li class="step" :class="orderInfo.pro_status > 2 || orderInfo.customized_status>6 ? 'past' : ''">
                            <div>
                                <span class="text">确认展台备料制作中</span>
                            </div>
                        </li>
                        <li class="step" :class="orderInfo.pro_status > 3 || orderInfo.customized_status>6 ? 'past' : ''">
                            <div>
                                <span class="text">确认展台试搭完成</span>
                            </div>
                        </li>
                        <li class="step" :class="orderInfo.pro_status > 4 || orderInfo.customized_status>6 ? 'past' : ''">
                            <div>
                                <span class="text">确认质检合格</span>
                            </div>
                        </li>
                        <li class="step" :class="orderInfo.pro_status > 5 || orderInfo.customized_status>6 ? 'past' : ''">
                            <div>
                                <span class="text">确认包装完成待发货</span>
                            </div>
                        </li>
                    </ul>
                </div>


                <div class="d-block" v-if="proDetails[0]&&proDetailshow" v-for="(proDetail) in proDetails">
                    <div class="d-title"><span class="step">{{timeResolve(proDetail.ctime)}}</span>{{proDetail.msg}}</div>
                    <div v-html="proDetail.readme"></div>
                </div>
                <div class="state-handle" v-if="orderInfo.customized_status>=6&&proDetails[0]">
                    <span class="btn" style="border: 1px solid #FF7159 !important; pointer-events: all !important;" @click="openpro()">{{proDetailshowtip}}</span>
                    <span class="btn"><img src="@/assets/image/orderok.svg"></span>
                </div>
                <div class="state-handle" v-else><span class="btn" @click="openpro()">{{proDetailshowtip}}</span><span class="btn weikaishi">未开始</span></div>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第七步</span>制作完成，尾款待支付</div>
                <div class="state-handle" v-if="orderInfo.customized_status>=7"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第八步</span>已付清，待发货</div>
                <div class="state-handle" v-if="orderInfo.customized_status>=8"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>

            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第九步</span>已发货，待收货</div>
                <div class="state-handle" v-if="orderInfo.customized_status>=9"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
                <table v-if="orderInfo.customized_status>=9" class="info-table">
                    <tbody>
                    <template v-for="delivery in orderInfo.delivery">
                        <tr>
                            <th>快递公司：</th>
                            <td>{{delivery['logi_name']}}</td>
                        </tr>
                        <tr>
                            <th>快递单号：</th>
                            <td>{{delivery['logi_no']}}</td>
                        </tr>
                        <tr>
                            <th>快递寄出时间：</th>
                            <td>{{timeResolve(delivery['ctime'])}}</td>
                        </tr>
                        <tr>
                            <th>收件人姓名：</th>
                            <td>{{delivery['ship_name']}}</td>
                        </tr>
                        <tr>
                            <th>收件人手机：</th>
                            <td>{{delivery['ship_mobile']}}</td>
                        </tr>
                        <tr>
                            <th>收件地址：</th>
                            <td>{{delivery['ship_area_id_name']}}{{delivery['ship_address']}}</td>
                        </tr>
                        <tr>
                            <th>备注：</th>
                            <td>{{delivery['memo']}}</td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="d-block">
                <div class="d-title"><span class="step">第十步</span>已收货，定制订单完成</div>
                <div class="state-handle" v-if="orderInfo.customized_status>=10"><span class="btn"><img src="@/assets/image/orderok.svg"></span></div>
                <div class="state-handle" v-else><span class="btn weikaishi">未开始</span></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {timeToDate} from '@/utils';
    import DemandTable from '@/components/zqtool/DemandTable.vue';
    import DesTable from '@/components/zqtool/DesTable.vue';
    export default {
        name: 'cusOrderDetail',
        components: {DemandTable,DesTable},
        props: {},
        data() {
            return {
                centerDialogVisible: false,
                order_id: '',
                activities: [], //物流详情
                orderInfo: {},
                proDetails:[],
                userInfo:this.$storage.get('userInfo'),
                proDetailshow:false,
                desInfo:{},
                proDetailshowtip:"展开生产细节",
                lading: {
                    status: false,
                    code: ''
                }, //提货信息

            }
        },
        watch: {},
        computed: {

//获取定制订单状态文字显示
            getCusOrderStatus() {
                return order => {
                    let orderStatusName;
                    switch (order.customized_status) {
                        case 1:
                            orderStatusName = "需求提交，保证金未支付";
                            break;
                        case 2:
                            orderStatusName = "保证金已支付，待分配设计师";
                            break;
                        case 3:
                            orderStatusName = "设计师已分配，方案制作中";
                            break;
                        case 4:
                            orderStatusName = "定制方案已提交，待确认";
                            break;
                        case 5:
                            orderStatusName = "定制方案已提交，待确认";
                            break;
                        case 6:
                            orderStatusName = "首款已支付，制作中";
                            break;
                        case 7:
                            orderStatusName = "制作完成，尾款待支付";
                            break;
                        case 8:
                            orderStatusName = "已付清，待发货";
                            break;
                        case 9:
                            orderStatusName = "已发货，待收货";
                            break;
                        case 10:
                            orderStatusName = "已收货，定制订单完成";
                            break;
                    }
                    return orderStatusName;
                };
            },
            timeResolve() {
                return time => {
                    return timeToDate(time)
                }
            },

            returnTime() {
                return val => {
                    let date = val.split(' ')
                    return (
                        date[0].substring(5, date[0].length) + ' ' + date[1].substring(0, 5)
                    )
                }
            },
        },
        methods: {
            getdesigninfo(id){
                let data = {
                    id: id
                };
                this.$api.getDesignInfo(data).then(res => {
                    if (res.status) {
                        this.desInfo=Object.assign({},this.orderInfo,res.data);
                    }
                });
            },
            openpro(){
                this.proDetailshow=!this.proDetailshow;
                if(this.proDetailshow){
                    this.proDetailshowtip="收起生产细节";
                }else{
                    this.proDetailshowtip="展开生产细节";
                }
            },
            tackDelivery(order_id) {
                this.$confirm("确定已收到宝贝?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let data = {
                        order_id: order_id
                    };
                    this.$api.confirmOrder(data).then(res => {
                        if (res.status) {
                            this.$msg("确认收货成功!");
                            this.getOrderDetail();
                        }
                    });
                });
            },
            redes(){
                this.$confirm("确定要重新设计", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    let data = {
                        order_id: this.order_id
                    };
                    this.$api.redesOrder(data).then(res => {
                        if (res.status) {
                            this.$msg(res.msg);
                            this.$router.push({name: 'myCurOrder'})
                        }
                    });
                });
            },
            toPay(order_id) {
                this.btnLoading = false
                this.$router.push({
                    name: 'cashier',
                    params: {
                        order_id: order_id,
                    },
                })
            },
            getOrderDetail() {
                let data = {
                    order_id: this.order_id,
                }
                this.$api.orderDetail(data).then(res => {
                    if (res.status) {

                        let data = res.data
                        this.orderInfo=Object.assign({},this.orderInfo,data)
                        console.log("orderInfo",this.orderInfo);
                        console.log("design_id",res.data);
                        if(res.data.design_id){

                            this.getdesigninfo(res.data.design_id)
                        }
                        this.$api.orderProDetail(data).then(res => {
                            if (res.status) {

                                let data = res.data
                                this.proDetails=Object.assign({},this.proDetails,data);
                                console.log("proDetails",this.proDetails);

                            }
                        });
                    }
                });

            },

        },
        created() {
        },
        mounted() {
            let orderId = this.$route.params.order_id
            this.order_id = orderId
            this.getOrderDetail()
        },
    }
</script>
<style lang="scss" scoped>
    @import '@/assets/css/mixin.scss';
    @import '@/assets/css/variable.scss';

    .cart-discount {
        padding: 15px 30px;
        text-align: right;

        .old,
        .discount {
            line-height: 24px;

            span {
                display: inline-block;

                &.text {
                    width: 100px;
                }

                &.num {
                    min-width: 100px;
                    color: $theme-color;
                }

                &.total {
                    margin-top: 10px;
                    font-size: 24px;
                }
            }
        }
    }

    .wrapper {
        .wl-container {
            padding: 30px;
        }

        .d-block {
            padding-bottom: 20px;
            position: relative;

            &:not(:last-of-type) {
                border-bottom: 1px solid $border;
                margin-bottom: 20px;
            }

            .d-top {
                position: relative;
                height: auto;
                line-height: 30px;
            }

            span.theme {
                color: $theme-color;
                margin-right: 28px;
            }

            b {
                font-weight: bold;
            }

            .d-title {

                font-size: 18px;
                margin-bottom: 15px;

                .step {
                    margin-right: 20px;
                }
            }

            .info-table {
                color: #757575;

                tr {
                    height: 30px;
                    line-height: 30px;
                }

                .info-div {
                    // height: 30px;
                    line-height: 30px;
                }
            }

            .state-handle {
                position: absolute;
                right: 0;
                top: 0;

                .btn {
                    height: 30px;
                    line-height: 30px;
                    display: inline-block;
                    text-align: center;
                    cursor: pointer;
                    margin-left: 30px;
                    color: $theme-color;
                    border: 1px solid $theme-color;
                    width: 100px;
                    transition: all 0.2s;

                    a {
                        display: block;
                    }

                    &:hover {
                        background: $theme-color;
                        color: #fff;
                    }
                }
                .weikaishi{
                    color: $border;
                    border: 1px solid $border;
                    a {
                        display: block;
                    }

                    &:hover {
                        background: #fff;
                        color: $border;
                    }
                }

            }

            .d-order {
                .order-box {
                    display: flex;
                    align-items: center;
                    height: 100px;
                    border-bottom: 1px solid $border;

                    &.head {
                        height: 40px;
                        line-height: 40px;

                        .order-info {
                            text-indent: 30px;
                        }
                    }

                    .order-info {
                        width: 450px;
                        display: inline-flex;
                        align-items: center;

                        .order-img {
                            display: inline-block;
                            width: 80px;
                            height: 80px;
                            border: 1px solid $border;
                            margin-top: 5px;
                            margin-right: 10px;
                            object-fit: cover;
                        }

                        .order-name {
                            display: inline-block;
                            line-height: 20px;
                        }
                    }

                    .order-price {
                        width: 100px;
                        text-align: center;
                    }

                    .order-num {
                        width: 100px;
                        text-align: center;
                    }

                    .order-shape {
                        width: 100px;
                        text-align: center;
                    }

                    .order-grade {
                        width: 80px;
                        text-align: center;
                    }

                    .order-total-price {
                        flex: 1;
                        color: $theme-color;
                        text-align: center;
                    }
                }
            }
        }

        .wl {
            position: relative;
            margin: 10px 0;

            .title {
                position: absolute;
                left: 0;
                top: 0;
                line-height: 1.4;
            }

            .info {
                margin-left: 60px;
                line-height: 1.4;

                .look-detail {
                    color: $theme-color;
                    cursor: pointer;
                }
            }
        }

        .order-progress {
            margin: 20px auto 30px;

            .progress-list {
                display: flex;
                height: 20px;
                line-height: 20px;
                padding: 0;
                margin: 0 auto;
                border-radius: 10px;
                font-size: 12px;
                text-align: center;
                color: #424242;

                .step {
                    width: 180px;
                    background-color: #eee;

                    &:first-of-type {
                        border-top-left-radius: 20px;
                        border-bottom-left-radius: 20px;
                    }

                    &:last-of-type {
                        border-top-right-radius: 20px;
                        border-bottom-right-radius: 20px;
                    }

                    &.active {
                        color: #fff;
                        border-top-right-radius: 20px;
                        border-bottom-right-radius: 20px;
                        background-color: $theme-color;
                    }

                    &.past {
                        color: #fff;
                        background-color: $theme-color;
                    }
                }
            }
        }
    }
    .step{
        img{ max-width: 100% !important;}
    }
    .noborder{
        .btn{border: 0px !important; pointer-events: none;
        img{ width: 25px;}
        }
    }
</style>
